import { __awaiter } from "tslib";
/**
 * Created by wuyanbin on 2019/7/15
 */
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { notification } from 'antd';
const initData = {
    isEditAble: false,
};
const priceVisibilityConfig = {
    isPriceVisibility: 0,
    id: '',
};
export default createStore({
    state: Object.assign(Object.assign({}, initData), priceVisibilityConfig),
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        RESET_STATE(state) {
            return Object.assign({}, initData);
        },
    },
    effects: {
        resetState(params) {
            this.SET_STATE(Object.assign(Object.assign({}, initData), params));
        },
        handleChange(payload, { state, update }) {
            this.SET_STATE({
                [payload.type]: payload.value,
            });
        },
        toggleEditAble(payload, { state }) {
            this.SET_STATE({
                isEditAble: !state.isEditAble,
            });
        },
        // 查询规则
        getRuleData(payload, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield Api.auction.getReserveTipsRule(payload).then((res) => {
                    if (res) {
                        this.SET_STATE({
                            id: res.id,
                            isPriceVisibility: res.watchCarPriceSwitch,
                            isEditAble: false,
                        });
                    }
                });
            });
        },
        // 保存
        save(payload, { state, rootState, update }) {
            const ruleData = {
                id: state.id,
                watchCarPriceSwitch: Number(state.isPriceVisibility),
            };
            Api.auction.saveReserveTipsRule(ruleData).then((res) => {
                if (res) {
                    this.SET_STATE({ isEditAble: false });
                    notification.success({ message: '保存成功' });
                }
                else {
                    notification.error({ message: '保存失败,请稍后重试' });
                }
            });
        },
        // 取消
        cancel(payload, { state, update }) {
            this.getRuleData({});
        },
    },
});
